import * as z from "zod/v4";

export const getOrderByNumber = {
  name: "getOrderByNumber" as const,
  input: z.object({ orderNumber: z.string(), email: z.string() }),
  output: z.object({ id: z.string(), orderDate: z.date() }),
};
